import { defineStore } from 'pinia'
import moment from 'moment'
import config from '@/services/config'
import { DASHBOARD_PARTS, DASHBOARD_SOPO_DETAIL, DASHBOARD_PARTS_STREAM_STOCK } from '@/data/url'
import apiClient from '@/services/apiClient'

const defaultState = () => ({
    figureKey: 0,
    customer: '',
    vendor: '',
    date_range: 'this_quarter',
    range: [moment().startOf('quarter').toDate(), moment().endOf('quarter').toDate()],
    queryDataRaw: {},
    stock_data: [],
    searchDataRaw: [],
    response_buffer: '',
    loading: false,
    error: null,
})

export const useDashboardPartsStore = defineStore('dashboardParts', {
    state: () => ({
        ...defaultState(),
    }),
    actions: {
        resetDashboardParts() {
            this.customer = ''
            this.vendor = ''
            this.date_range = 'this_quarter'
            this.range = [moment().startOf('quarter').toDate(), moment().endOf('quarter').toDate()]
        },
        addToFigureKeyParts(addValue) {
            this.figureKey += addValue
        },
        async fetchDashboardParts({ begin_date, end_date, customer = this.customer, vendor = this.vendor } = {}) {
            this.loading = true
            this.error = null
            this.queryDataRaw = {}

            try {
                const response = await apiClient.post(DASHBOARD_PARTS, {
                    begin_date,
                    end_date,
                    customer,
                    vendor,
                })

                const data = response.data
                if (data?.success) {
                    this.queryDataRaw = data.data || {}
                } else {
                    this.queryDataRaw = {}
                }

                return data
            } catch (error) {
                this.error = error instanceof Error ? error.message : 'Unknown error'
                console.error('Failed to fetch dashboard parts', error)
                throw error
            } finally {
                this.loading = false
            }
        },
        async fetchDashboardDetail({ begin_date, end_date } = {}) {
            this.loading = true
            this.error = null

            try {
                const response = await apiClient.post(DASHBOARD_SOPO_DETAIL, {
                    begin_date,
                    end_date,
                })

                const data = response.data
                if (data?.success) {
                    this.queryDataRaw = data.data || {}
                } else {
                    this.queryDataRaw = {}
                }

                return data
            } catch (error) {
                this.error = error instanceof Error ? error.message : 'Unknown error'
                console.error('Failed to fetch dashboard detail', error)
                throw error
            } finally {
                this.loading = false
            }
        },
        async streamStock(part_number_list = []) {
            try {
                const response = await fetch(`${config.backendURL}${DASHBOARD_PARTS_STREAM_STOCK}`, {
                    method: 'POST',
                    body: JSON.stringify({ part_number_list }),
                    headers: {
                        Authorization: `Bearer ${config.sessionToken}`,
                        'Content-Type': 'application/json',
                    },
                })

                if (!response.ok || !response.body) {
                    throw new Error(`Request failed with status ${response.status}`)
                }

                return response.body.getReader()
            } catch (error) {
                this.error = error instanceof Error ? error.message : 'Unknown error'
                console.error('Failed to stream stock', error)
                throw error
            }
        },
    },
})
